import React from 'react';
import { FormattedMessage } from 'react-intl';
import { DocumentInfo } from './documentTypes';
import messages from '../text/messages';

export class Signatures {
    static get types() {
        return {
            ARBITRATION: { name: 'JobArbitrationAgreement', label: <FormattedMessage {...messages.signatureAndArbitration} /> },
            ASSIGNMENT_LETTER_W2: {
                name: 'JobAssignmentL_Signature_W2',
                document: DocumentInfo.types.CONTRACTOR_ASSIGNMENT_W2,
                label: <FormattedMessage {...messages.assignmentLetter} />
            },
            ASSIGNMENT_LETTER_IC: {
                name: 'JobAssignmentL_Signature_IC',
                document: DocumentInfo.types.CONTRACTOR_ASSIGNMENT_IC,
                label: <FormattedMessage {...messages.assignmentLetter} />
            },
            OFFER_LETTER: {
                name: 'JobOfferLetter_Signature',
                document: DocumentInfo.types.CONTRACTOR_OFFER_LETTER,
                label: <FormattedMessage {...messages.offerLetter} />
            },
            IC_AGREEMENT: {
                name: 'JobICAgreement_Signature',
                document: DocumentInfo.types.CONTRACTOR_ICAGREEMENT,
                label: <FormattedMessage {...messages.contractorAgreement} />
            },
            BG_CHECK_AUTHORIZATION: {
                name: 'JobBackgroundCheck_Authorization',
                label: <FormattedMessage id={'signature.bg_authorization'} defaultMessage={'Background check authorization Signature'} />
            },
            BG_CHECK_CDRB: {
                name: 'JobBackgroundCheck_CDRB_Agreement',
                label: <FormattedMessage id={'signature.bg_cdrb'} defaultMessage={'Background check California Disclosure Signature'} />
            },
            BG_CHECK_DRB: {
                name: 'JobBackgroundCheck_DRB_Agreement',
                label: <FormattedMessage id={'signature.bg_drb'} defaultMessage={'Disclosure Regarding Background Investigation Signature'} />
            },
            BG_CHECK_FCRA: {
                name: 'JobBackgroundCheck_FCRA_Agreement',
                label: <FormattedMessage id={'signature.bg_fcra'} defaultMessage={'Fair Credit Reporting Act Signature'} />
            },
            DIRECT_DEPOSIT_PREFEERENCES: {
                name: 'JobDirectDeposit_CheckPreference',
                label: <FormattedMessage id={'signature.directDeposit'} defaultMessage={'Direct Deposit Preference Signature'} />
            },
            EMPLOYEE_HANDBOOK_AGREEMENT: {
                name: 'JobEmployeeHandbook_Agreement',
                document: DocumentInfo.types.ADMIN_EMPLOYEE_HANDBOOK,
                label: <FormattedMessage {...messages.employeeHandbook} />
            },
            EMPLOYEE_HANDBOOK_AGREEMENT_UK: {
                name: 'JobEmployeeHandbook_Agreement',
                document: DocumentInfo.types.ADMIN_EMPLOYEE_HANDBOOK_UK,
                label: <FormattedMessage {...messages.employeeHandbook} />
            },
            INSURANCE_AND_BENEFITS: { name: 'JobInsuranceAndBenefits_Agreement', label: <FormattedMessage {...messages.insuranceAndBenefits} /> },
            NEW_STARTER_CHECKLIST: { name: 'NewStarterChecklist', label: <FormattedMessage {...messages.newStaterInfo} /> }
        };
    }
}



// WEBPACK FOOTER //
// ./src/utilities/signatureTypes.jsx